/**
 * Agents request cancellations through underwriting (#37502). On a brand with an underwriting inbox for
 * cancellation requests (brandConfig.agentCancellationRequestEmail: CFM, Forreston), an agent can't
 * cancel a policy; the insured signs a cancellation request and the agent sends it to that inbox.
 * policy-mod rejects an agent's cancellation preview on the same brands, with this same sentence as the
 * error (staff-appsync-be/lambdas/policy-mod/helpers/agent-cancellation.ts); keep them in sync.
 *
 * Returns the note an agent sees in place of the Cancel Policy button, or null when the button stays
 * (internal staff, or a brand without the inbox).
 */
export function getAgentCancellationNote(brandConfig, { isAgency }) {
  const email = brandConfig?.agentCancellationRequestEmail;
  if (!isAgency || !email) {
    return null;
  }
  return `To cancel a policy, please have your insured sign a cancellation request and submit it to underwriting at ${email}.`;
}
